import type { NativeStackNavigationOptions } from "@react-navigation/native-stack";
import { Platform } from "react-native";

export const COMMUTE_SHEET_MAX_HEIGHT_RATIO = 0.9;

/**
 * iOS lays form-sheet content out at its natural height rather than the detent
 * height, so a fixed fraction clipped the footer on short screens. Android has
 * no `fitToContents`, so it takes the fraction instead. `CommutePreferenceModal`
 * caps itself at the same ratio so tall content scrolls.
 */
export function getCommutePreferenceModalScreenOptions(
  isDesktopDisplay: boolean,
): NativeStackNavigationOptions {
  if (isDesktopDisplay) {
    return {
      headerShown: false,
      presentation: "transparentModal",
    };
  }

  return {
    headerShown: false,
    presentation: "formSheet",
    sheetAllowedDetents: Platform.OS === "ios" ? "fitToContents" : [COMMUTE_SHEET_MAX_HEIGHT_RATIO],
    sheetCornerRadius: 20,
    gestureEnabled: true,
  };
}
